/* CyberpunkLightbox.module.css */

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 15, 0.92);
  backdrop-filter: blur(8px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease;
}

.container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: var(--bg-surface);
  border: 1px solid var(--neon-cyan);
  box-shadow: 0 0 20px var(--neon-cyan), 0 0 40px rgba(0, 240, 255, 0.2);
  padding: 20px;
  overflow: hidden;
}

.closeBtn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: 1px solid var(--neon-magenta);
  color: var(--neon-magenta);
  font-family: var(--font-mono);
  font-size: 12px;
  padding: 4px 10px;
  cursor: pointer;
  z-index: 10;
  letter-spacing: 0.1em;
  box-shadow: 0 0 5px var(--neon-magenta);
  transition: all 0.2s ease;
}

.closeBtn:hover {
  background: rgba(255, 45, 149, 0.1);
  box-shadow: 0 0 10px var(--neon-magenta);
}

/* Scanline animation */
.scanline {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: rgba(0, 240, 255, 0.25);
  z-index: 5;
  pointer-events: none;
  animation: scanMove 3s linear infinite;
}

.imageWrapper {
  position: relative;
  overflow: hidden;
}

.image {
  max-width: 80vw;
  max-height: 75vh;
  display: block;
  object-fit: contain;
  filter: saturate(0.8) contrast(1.15);
  box-shadow: 0 0 30px rgba(0, 240, 255, 0.15);
}

/* Glitch on image */
.glitchLayer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 0, 255, 0.08) 0%,
    rgba(0, 255, 255, 0.08) 100%
  );
  mix-blend-mode: screen;
  pointer-events: none;
  animation: glitchPulse 4s ease-in-out infinite;
}

/* CRT scanlines */
.crtOverlay {
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.12) 0px,
    rgba(0, 0, 0, 0.12) 1px,
    transparent 1px,
    transparent 2px
  );
  pointer-events: none;
}

/* Footer */
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(0, 240, 255, 0.15);
}

.filename {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--text-data);
  letter-spacing: 0.1em;
}

.pulse {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--neon-green);
  letter-spacing: 0.1em;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* ── 日记体布局（画面 + 文案） ── */

.soloLayout {
  display: block;
}

.containerDiary {
  max-width: 92vw;
}

.diaryLayout {
  display: flex;
  align-items: stretch;
  gap: 0;
}

.diaryLayout .imageWrapper {
  flex: 0 1 auto;
  min-width: 0;
}

.diaryLayout .image {
  max-width: 52vw;
  max-height: 72vh;
  height: 100%;
  object-fit: cover;
}

/* 日记文案面板 */
.diaryPanel {
  flex: 1 1 320px;
  min-width: 280px;
  max-width: 420px;
  max-height: 72vh;
  overflow-y: auto;
  padding: 18px 20px;
  border-left: 1px solid rgba(0, 240, 255, 0.3);
  background:
    repeating-linear-gradient(
      0deg,
      rgba(0, 240, 255, 0.03) 0px,
      rgba(0, 240, 255, 0.03) 1px,
      transparent 1px,
      transparent 3px
    ),
    rgba(10, 10, 15, 0.55);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.diaryDate {
  font-family: var(--font-mono);
  font-size: 12px;
  letter-spacing: 0.18em;
  color: var(--neon-magenta);
  text-shadow: 0 0 6px var(--neon-magenta);
}

.diaryTitle {
  margin: 0;
  font-family: var(--font-display);
  font-size: 22px;
  line-height: 1.3;
  color: var(--neon-cyan);
  text-shadow: var(--glow-sm) var(--neon-cyan);
  letter-spacing: 0.06em;
  word-break: break-word;
}

.diaryText {
  margin: 0;
  font-family: var(--font-cjk), var(--font-mono);
  font-size: 14px;
  line-height: 1.9;
  color: var(--text-primary);
  white-space: pre-wrap;
  word-break: break-word;
  flex: 1;
}

.diaryMeta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  border-top: 1px dashed rgba(0, 240, 255, 0.2);
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.12em;
  color: var(--text-muted);
}

@media (max-width: 768px) {
  .diaryLayout {
    flex-direction: column;
  }

  .diaryLayout .image {
    max-width: 82vw;
    max-height: 46vh;
  }

  .diaryPanel {
    max-width: none;
    max-height: 32vh;
    border-left: none;
    border-top: 1px solid rgba(0, 240, 255, 0.3);
  }
}

@keyframes scanMove {
  from { top: 0; }
  to { top: 100%; }
}

@keyframes glitchPulse {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

@media (prefers-reduced-motion: reduce) {
  .scanline,
  .glitchLayer,
  .pulse {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
  .overlay {
    animation: none;
  }
}
